import fetchProperty from '../../../services/object'

const categorizar = (arr = [], type) => {
  const key = 'obra.categoria_obra.descricao'

  const posts = arr?.reduce((acc, item) => {
    if (!acc[fetchProperty(item, key)]) acc[fetchProperty(item, key)] = []
    acc[fetchProperty(item, key)].push({
      mes: item.mes_id,
      numero_pagina: item.obra.numero_pagina
    })
    return acc
  }, {})

  const categorias = []
  arr.forEach(item => {
    if (
      !categorias.find(
        categoria => item.obra.categoria_obra.descricao === categoria
      )
    )
      categorias.push(item.obra.categoria_obra.descricao)
  })
  const se = types[type](categorias, posts)
  return se
}

const line = (categorias, posts) => {
  return categorias.map(categoria => {
    const meses = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    posts[categoria].forEach(mes => {
      meses[mes.mes - 1] += 1
    })
    return { name: categoria, data: meses }
  })
}

const donut = (categorias, posts) => {
  const series = []
  categorias.forEach((categoria, index) => {
    series[index] = posts[categoria].length
  })
  return { labels: categorias, series }
}

const radial = (categorias, posts) => {
  let number = 0
  categorias.forEach(categoria => {
    posts[categoria].forEach(post => {
      number += post.numero_pagina
    })
  })
  return number
}

const numeroPaginas = (categorias, posts) => {
  const meses = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

  const result = categorias.map(categoria => {
    posts[categoria].forEach(mes => {
      meses[mes.mes - 1] += mes.numero_pagina
    })

    return { data: meses }
  })

  return result[0] !== undefined ? [result[0]] : [{ data: [] }]
}

const types = { line, donut, radial, numeroPaginas }

const constructSeries = (postagens, type) => {
  const result = categorizar(postagens, type)
  return result
}

// mes/ano, departamento, função, leitor

export default constructSeries
